import { PubSub } from 'utils/PubSub';

export interface LogMessage {
  ts: Date;
  msg?: string;
  itemType: string;
  itemId?: string;
  status:
    | 'calling'
    | 'complete'
    | 'debug'
    | 'error'
    | 'executed'
    | 'info'
    | 'query'
    | 'save'
    | 'skipped'
    | 'starting'
    | 'trace'
    | 'validate'
    | 'warn';
  level: number;
  key: number;
  onRender?: boolean;
}

class Logger {
  logs: LogMessage[] = [];

  pubsub = new PubSub();

  level = 0;

  counter = 0;

  enabled = true;

  timer: NodeJS.Timeout | undefined = undefined;

  isLogEnabled() {
    return this.enabled;
  }

  setEnabled(e: boolean) {
    this.enabled = e;
  }

  log(msg: Omit<LogMessage, 'key' | 'ts' | 'level'>): void {
    if (!this.enabled) return;
    const m: LogMessage = {
      ...msg,
      ts: new Date(),
      level: this.level,
      key: this.counter,
    };
    this.counter++;
    this.logs = [...this.logs, m];
    if (msg.onRender) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        delete this.timer;
        this.pubsub.pub('Change', {});
      }, 10000);
    } else {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.pubsub.pub('Change', {});
    }
  }

  trace(...msg: any[]) {
    this.log({
      msg: msg
        .map((m) => (typeof m === 'object' ? JSON.stringify(m) : m))
        .join(' '),
      itemType: '',
      status: 'trace',
    });
  }

  clear() {
    this.logs = [];
    this.pubsub.pub('Change', {});
  }

  increaseLevel() {
    this.level++;
  }

  decreaseLevel() {
    this.level--;
  }

  getLogs(): LogMessage[] {
    return this.logs;
  }
}

export default new Logger();
